import Inbox from "./pages/dashboard/inbox/inbox";
import Connect from "./pages/dashboard/connect/connect";
import Contact from "./pages/dashboard/contact/contact";
import Settings from "./pages/dashboard/settings/settings";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Dashboard from "./pages/dashboard/dashboard";
import Login from "./pages/auth/login/login";
import OTPVerification from "./pages/auth/otp/otp";
import VerifyEmail from "./pages/auth/verify_email/verify_email";
import PersonalData from "./pages/auth/personal_data/personal_data";
import GoogleSuccess from "./pages/auth/google_success/google_success";
import GoogleFailed from "./pages/auth/google_failed/google_failed";
import SelectNumber from "./pages/auth/select_number/select_number";
import SelectSubscription from "./pages/auth/select_subscription/select_subscription";
import PurchaseSuccess from "./pages/auth/purchase_status/purchase_success";
import PurchaseFail from "./pages/auth/purchase_status/purchase_fail";
import { Navigate } from "react-router-dom";
import Myprofile from "./pages/dashboard/settings/myprofile/myprofile";
import Myteam from "./pages/dashboard/settings/myteam/myteam";
import MyBusiness from "./pages/dashboard/settings/mybusiness/mybusiness";
import { Toaster } from "react-hot-toast";
import BusinessWithContext from "./pages/dashboard/settings/business/index";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReportsAndBilling from "./pages/dashboard/settings/reportsandbilling/reportsandbilling";
import { Reserved } from "./pages/auth/reserved/reserved";
import PostLogin from "./pages/auth/post_login/PostLogin";
import ForbiddenErrorPopup from "./components/ForbiddenErrorPopup";
import { useForbiddenError } from "./hooks/useForbiddenError";

const router = createBrowserRouter([
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/post-login",
    element: <PostLogin />,
  },
  {
    path: "/otp",
    element: <OTPVerification />,
  },
  {
    path: "/verify_email/:token",
    element: <VerifyEmail />,
  },
  {
    path: "/select_number",
    element: <SelectNumber />,
  },
  {
    path: "/select_subscription",
    element: <SelectSubscription />,
  },
  {
    path: "/personal_data",
    element: <PersonalData />,
  },
  {
    path: "/google_success/:token",
    element: <GoogleSuccess />,
  },
  {
    path: "/google_failed",
    element: <GoogleFailed />,
  },
  {
    path: "/purchase_success",
    element: <PurchaseSuccess />,
  },
  {
    path: "/purchase_fail",
    element: <PurchaseFail />,
  },
  {
    path: "/reserved",
    element: <Reserved />,
  },
  {
    path: "/",
    element: <Dashboard />,
    children: [
      {
        path: "inbox",
        element: <Inbox />,
      },
      {
        path: "connect",
        element: <Connect />,
      },
      {
        path: "contact",
        element: <Contact />,
      },
      {
        path: "settings",
        element: <Settings />,
        children: [
          {
            index: true,
            element: <Navigate to="myprofile" />,
          },
          {
            path: "myprofile",
            element: <Myprofile />,
          },
          {
            path: "mybusiness",
            element: <MyBusiness />,
          },
          {
            path: "myteam",
            element: <Myteam />,
          },
          {
            path: "business",
            element: <BusinessWithContext />,
          },
          {
            path: "reports",
            element: <ReportsAndBilling />,
          },
        ],
      },
    ],
  },
]);

function App() {
  const {
    error: forbiddenError,
    isOpen: isForbiddenOpen,
    closeError: closeForbiddenError,
  } = useForbiddenError();

  return (
    <>
      <RouterProvider router={router} />
      <Toaster position="top-right" />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      {/* Global 403 Error Popup */}
      <ForbiddenErrorPopup
        isOpen={isForbiddenOpen}
        onClose={closeForbiddenError}
        message={
          forbiddenError?.message ||
          "Access forbidden. You do not have permission to perform this action."
        }
      />
    </>
  );
}

export default App;
